import { FontIcon, Text, mergeStyles, Panel, PanelType, Stack, useTheme, ProgressIndicator, PrimaryButton, DefaultButton, MessageBar } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { AttendeeDetailForm } from './AttendeeDetailForm';

interface IAttendeeDetailViewProps {    
    item: IAttendee;
    isOpen: boolean;
    isLoading: boolean;
    propertyChanged: (key: string, value: any) => void;
    close: () => void;
    statusMessage?: IStatusMessage
    updateAttendee: (item: IAttendee) => void;
    createAttendee: (item: IAttendee) => void;
    minAge?: number;
    maxAge?: number;
}


export const AttendeeDetailView: React.FunctionComponent<IAttendeeDetailViewProps> = (props) => {

    const [isFormValid, setIsFormValid] = React.useState(false);

    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    return (
             <>
            {props.isOpen ?
                <Panel
                    isOpen={props.isOpen}
                    onDismiss={props.close}
                    type={PanelType.medium}
                    closeButtonAriaLabel="Zavřít">
                    <Stack>
                        <Stack horizontal>
                            <Stack horizontalAlign='end' styles={{ root: { width: 80 } }}>
                                <FontIcon iconName="TestUserSolid" className={iconClass} />
                            </Stack>

                            <Stack horizontal verticalAlign="center">
                                <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">
                                    {props.item.id === 0 ? "Vytvoření nové osoby" : props.item.firstName + " " + props.item.lastName}
                                </Text>
                            </Stack>
                        </Stack>
                        <AttendeeDetailForm paddingTop={20 } isLoading={props.isLoading} item={props.item} propertyChanged={props.propertyChanged} valid={setIsFormValid} minAge={props.minAge} maxAge={props.maxAge} />

                        <Stack styles={{ root: { height: 10 } }}>
                            {props.isLoading ? <ProgressIndicator /> : null}
                        </Stack>

                        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
                            <PrimaryButton disabled={!isFormValid} onClick={() => props.item.id > 0 ? props.updateAttendee(props.item) : props.createAttendee(props.item)}>Uložit</PrimaryButton>
                            <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
                        </Stack>
                        {props.statusMessage && props.statusMessage.message ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
                    </Stack>
                </Panel> : null
            }
        </>
  )
}
